import { Component, ElementRef, OnInit, Renderer2, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { SystemService } from "../../services/system.service";
import { CallResponseService } from "../../services/callresponse";
import { AlertifyService } from "../../services/alertify.service";
import { CallResponse } from "../../model/callbackresponse";




@Component({
    selector:'app-callbackresponse',
    templateUrl:'callbackresponse.html'
})

export class CallBackResponseComponent implements OnInit{
    CallBackForm: FormGroup;
    callback: any;
   
    @ViewChild('blogContainer2') blogContainer: ElementRef; // Use 'blogContainer2' instead of 'blogContainer'
    rowData: any;
    gridApi: any;


    constructor(
        private fb: FormBuilder,
        private renderer: Renderer2,
        public service: SystemService,
        private callresponseService: CallResponseService,
        private alertify: AlertifyService,
    ) {
        this.loadCallbackResponse();
    }

    ngOnInit() {
        console.log('blogContainer:', this.blogContainer); // Add this line to check the value
       
        this.loadCallbackResponse();
    }
    refreshGridData(): void {
        //this.loadCategories();
        this.gridApi.setRowData(this.rowData); // Refresh the grid with the updated data
    }

    async onSubmit() {
        this.scrollIntoViewAdd(this.blogContainer.nativeElement);
        const callBack: CallResponse = this.CallBackForm.value;

        try {
            if (this.CallBackForm.valid) {
                this.service.App.ShowLoader = true;
                if (callBack.requestId) {
                    
                    await this.callresponseService.updateCallBack(callBack);
                    this.alertify.success("Data Updated Successfully");
                } else {
                    callBack.requestId = 0;
                    await this.callresponseService.addCallBack(callBack);
                }
                this.alertify.success("Data Saved Successfully");
                this.loadCallbackResponse();

                this.CallBackForm.reset();
                

                console.log('Scrolling to view:', this.blogContainer.nativeElement);
            }
        } finally {
            this.service.App.ShowLoader = false;
        }
    }
    scrollIntoViewAdd(element: any): void {
        const gridElement = document.querySelector('.blog-details-area'); // Assuming the grid is under the class 'blog-details-area'

        if (gridElement) {
            const totalHeight = gridElement.scrollHeight;
            const scrollTopValue = totalHeight - element.offsetTop;
            this.renderer.setProperty(document.documentElement, 'scrollTop', scrollTopValue);
        }
    }




    scrollIntoViewEdit(): void {
        const gridElement = document.querySelector('.blog-details-area') as HTMLElement;

        if (gridElement) {
            gridElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    onDelete(requestId: number) {
        const userConfirmed = confirm('Are you sure you want to delete?');
        if (userConfirmed) {
            this.callresponseService.deleteCallBack(requestId).then(() => {
                this.alertify.success("Deleted Successfully");
                this.loadCallbackResponse();  // Refresh the grid after deletion
            }).catch(error => {
                console.error('Error deleting response:', error);
                this.alertify.error("Error deleting data");
            }).finally(() => {
                this.service.App.ShowLoader = false;
            });
        } else {
            console.log('Deletion canceled.');
        }

    }

    loadCallbackResponse() {
        this.service.App.ShowLoader = true;
        this.callresponseService.getAllCallResponse().then(callresponse => {
            this.callback = callresponse;
            this.rowData = callresponse;
            this.refreshGridData();
            console.log(JSON.stringify(this.callback));
        });
        this.service.App.ShowLoader = false;
    }


}
